module.exports = __webpack_public_path__ + "img/kompanija2.f9257413.jpg";